export const FormSamplesInitialValuesPageInfo = () => {
    return (
        <>
            Initial values are passed to the FormControl via props.<br />
            The values must be of the interface type defined for this form.
        </>
    )
}
